import React from 'react';
import './LandingPageHeader.css';


function LandingPageHeader({ onNav = () => {}, phone }) {
  return (
    <header className="gsc-header">
      <div className="gsc-logo">
        <img src={process.env.PUBLIC_URL + '/logo.png'} alt="Granger Sports Complex" />
      </div>
      <nav className="gsc-nav">
        <button className="gsc-nav-link active" onClick={() => onNav('home')}>Home</button>
        <button className="gsc-nav-link" onClick={() => onNav('rental')}>Facility Rental</button>
        <button className="gsc-nav-link" onClick={() => onNav('waiver')}>Participant Waiver</button>
      </nav>
      <div className="gsc-phone">
        <button className="gsc-book-btn" onClick={() => onNav('login')}>Book Now</button>
        <a href="tel:2694208168">{phone || '269.420.8168'}</a>
      </div>
    </header>
  );
}

export default LandingPageHeader;
